// This is extracted from `RxDBHandler` in `src/rxdb/useRxDB.tsx`.
import { useEffect } from 'react';

import { saveSyncTimeToLocalStorage } from '../../../utilities/syncHelpers';
import { useReplication } from '../useReplication';

export function useSyncTimeSaver() {
  const replication = useReplication();

  useEffect(() => {
    if (replication) {
      const subscriptions = replication.replicationStates.map(rs => {
        const sub = rs.received$.subscribe(() => saveSyncTimeToLocalStorage());
        return sub;
      });
      return () => {
        subscriptions.forEach(sub => sub.unsubscribe());
      };
    }
  }, [replication]);
}
